import * as Types from '../../../../../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRiskScorePopoverDataVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.AIConversationsInput>;
}>;

export type GetRiskScorePopoverData = {
  aiConversations: {
    edges: Array<{
      node: Pick<Types.AIConversation, 'id'> & {
        streams: {
          edges: Array<{
            node: Pick<Types.AIInferenceStream, 'streamId'> & {
              riskScoreEvidence?: Types.Maybe<
                Pick<Types.RiskScoreEvidence, 'normalizedTotalRiskScore'> & {
                  benignIndicators: Array<Pick<Types.RiskIndicator, 'description'>>;
                  riskyIndicators: Array<Pick<Types.RiskIndicator, 'description'>>;
                }
              >;
            };
          }>;
        };
      };
    }>;
  };
};

export const GetRiskScorePopoverDataDocument = gql`
  query GetRiskScorePopoverData($input: AIConversationsInput) {
    aiConversations(input: $input) {
      edges {
        node {
          id
          streams(input: { pageSize: 1 }) {
            edges {
              node {
                streamId
                riskScoreEvidence {
                  normalizedTotalRiskScore
                  benignIndicators {
                    description
                  }
                  riskyIndicators {
                    description
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetRiskScorePopoverData__
 *
 * To run a query within a React component, call `useGetRiskScorePopoverData` and pass it any options that fit your needs.
 * When your component renders, `useGetRiskScorePopoverData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRiskScorePopoverData({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRiskScorePopoverData(
  baseOptions?: Apollo.QueryHookOptions<GetRiskScorePopoverData, GetRiskScorePopoverDataVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRiskScorePopoverData, GetRiskScorePopoverDataVariables>(
    GetRiskScorePopoverDataDocument,
    options,
  );
}
export function useGetRiskScorePopoverDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRiskScorePopoverData,
    GetRiskScorePopoverDataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRiskScorePopoverData, GetRiskScorePopoverDataVariables>(
    GetRiskScorePopoverDataDocument,
    options,
  );
}
export function useGetRiskScorePopoverDataSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetRiskScorePopoverData,
    GetRiskScorePopoverDataVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetRiskScorePopoverData, GetRiskScorePopoverDataVariables>(
    GetRiskScorePopoverDataDocument,
    options,
  );
}
export type GetRiskScorePopoverDataHookResult = ReturnType<typeof useGetRiskScorePopoverData>;
export type GetRiskScorePopoverDataLazyQueryHookResult = ReturnType<
  typeof useGetRiskScorePopoverDataLazyQuery
>;
export type GetRiskScorePopoverDataSuspenseQueryHookResult = ReturnType<
  typeof useGetRiskScorePopoverDataSuspenseQuery
>;
export type GetRiskScorePopoverDataQueryResult = Apollo.QueryResult<
  GetRiskScorePopoverData,
  GetRiskScorePopoverDataVariables
>;
export function mockGetRiskScorePopoverData({
  data,
  variables,
  errors,
}: {
  data: GetRiskScorePopoverData;
  variables?: GetRiskScorePopoverDataVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetRiskScorePopoverDataDocument, variables },
    result: { data, errors },
  };
}
